import axios from "../lib/axios";

// API function to get all users (only uid and name)
export const getAllMovies = async () => {
  try {
    const response = await axios.get("/movies"); // Adjust the endpoint as needed
    return response.data; // Assume API returns an array of users with uid and name
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getMovieById = async (id) => {
  try {
    const response = await axios.get(`/movies/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching movie by id:", error);
    throw error;
  }
};
